<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <section class="knowledge-test" aria-labelledby="knowledge-title">
    <header class="knowledge-test__header">
      <span class="knowledge-test__eyebrow">{{
        $t("Тест уровня знаний рынка")
      }}</span>
      <h2 id="knowledge-title">
        {{ $t("Тест уровня знаний и компетентности клиента") }}
      </h2>
      <p>{{ $t("Для совершения операций с виртуальными активами") }}</p>
    </header>

    <Transition name="knowledge-content" mode="out-in">
      <SettingsMarketTestSkeleton
        v-if="isVerified && !visibleResult && identityLoading"
        key="loading"
      />
      <SettingsMarketTestState
        v-else-if="stateView"
        :key="stateView.props.title"
        v-bind="stateView.props"
        :role="stateView.role"
        :aria-live="stateView.live"
        @action="handleStateAction"
      />

      <form
        v-else
        key="form"
        class="knowledge-test__form"
        @submit.prevent="submit"
        :aria-busy="submissionState === 'submitting'"
      >
        <aside class="knowledge-test__intro">
          <b>{{ $t("Порядок оценки результатов") }}</b>
          <p>{{ $t(assessmentRules) }}</p>
        </aside>
        <div class="knowledge-test__identity">
          <label
            ><span>{{ $t("Ф.И.О. / наименование клиента") }}<em>*</em></span
            ><input
              :value="client.name"
              :placeholder="$t('Данные отсутствуют')"
              readonly
          /></label>
          <label
            ><span>{{
              $t("Для юридического лица: Ф.И.О. ЕИО (представителя)")
            }}</span
            ><input
              :value="client.representative"
              :placeholder="client.legal ? $t('Данные отсутствуют') : '—'"
              readonly
          /></label>
          <label
            ><span>{{ $t("Дата заполнения") }}</span
            ><input class="knowledge-test__date" :value="filledDate" readonly
          /></label>
        </div>
        <p v-if="!client.complete" class="knowledge-test__missing" role="alert">
          {{
            $t(
              client.legal
                ? "В подтверждённой анкете отсутствуют обязательные данные клиента или представителя. Для уточнения данных обратитесь в поддержку."
                : "В подтверждённой анкете отсутствуют обязательные данные клиента. Для уточнения данных обратитесь в поддержку."
            )
          }}
        </p>

        <div class="knowledge-test__questions">
          <SettingsMarketTestQuestion
            v-for="(question, index) in questions"
            :key="index"
            v-model="selections[index]"
            :question="question"
            :index="index"
            :disabled="submissionState === 'submitting'"
          />
        </div>

        <SettingsMarketTestRisks
          v-model="risksAcknowledged"
          :risks="risks"
          :disabled="submissionState === 'submitting'"
        />

        <p
          v-if="submissionState === 'error'"
          class="knowledge-test__notice"
          role="alert"
        >
          {{
            submissionError ||
            $t("Не удалось отправить ответы. Попробуйте ещё раз.")
          }}
        </p>
        <p
          v-else-if="submissionNotice"
          class="knowledge-test__notice"
          role="status"
          aria-live="polite"
        >
          {{ $t(submissionNotice) }}
        </p>

        <SettingsMarketTestFooter
          :answered="answeredCount"
          :total="questions.length"
          :message="progressMessage"
          :disabled="!canSubmit"
          :submitting="submissionState === 'submitting'"
        />
      </form>
    </Transition>
  </section>
</template>
